<template>
  <Box
    v-if="type === 'box'"
    :box="component"
    :parentLayout="parentLayout"
    :parentSpacing="parentSpacing"
    :direction="direction"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
  <Image
    v-else-if="type === 'image'"
    :image="component"
    :parentLayout="parentLayout"
    :direction="direction"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
  <Video
    v-else-if="type === 'video'"
    :video="component"
    :parentLayout="parentLayout"
    :parentSpacing="parentSpacing"
    :direction="direction"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
  <Button
    v-else-if="type === 'button'"
    :button="component"
    :parentLayout="parentLayout"
    :direction="direction"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
  <Icon
    v-else-if="type === 'icon'"
    :icon="component"
    :parentLayout="parentLayout"
    :direction="direction"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
  <Text
    v-else-if="type === 'text'"
    :text="component"
    :parentLayout="parentLayout"
    :direction="direction"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
  <Span
    v-else-if="type === 'span'"
    :span="component"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
    :editPath="editPath"
    :isAdmin="isAdmin"
    @onSelectNode="selectNode"
    @initListNode="initListNode"
  />
  <Separator
    v-else-if="type === 'separator'"
    :separator="component"
    :parentLayout="parentLayout"
    :direction="direction"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
  />
  <Filler
    v-else-if="type === 'filler'"
    :filler="component"
    :parentPath="parentPath"
    :hoverPath="hoverPath"
  />
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import Box from '@/components/common/flex-message/components/Box.vue'
import Image from '@/components/common/flex-message/components/Image.vue'
import Button from '@/components/common/flex-message/components/Button.vue'
import Video from '@/components/common/flex-message/components/Video.vue'
import Icon from '@/components/common/flex-message/components/Icon.vue'
import Text from '@/components/common/flex-message/components/Text.vue'
import Span from '@/components/common/flex-message/components/Span.vue'
import Separator from '@/components/common/flex-message/components/Separator.vue'
import Filler from '@/components/common/flex-message/components/Filler.vue'
@Options({
  components: { Filler, Separator, Span, Text, Box, Button, Icon, Image, Video },
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class FlexMessageComponents extends Vue {
  @Prop()
  direction!: string

  @Prop()
  type!: string

  @Prop()
  component!: {}

  @Prop()
  parentLayout!: string

  @Prop()
  parentSpacing!: string

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  initListNode(path) {
    this.$emit('initListNode', path)
  }
}
</script>

<style scoped lang="scss">

</style>
